import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'maskEmail' })
export class MaskEmailPipe implements PipeTransform {
  transform(email: string): string {
    if (!email.includes('@')) return email;

    const [localPart, domainPart] = email.split('@');

    const visiblePart = localPart.substring(0, 3);

    const restLocal = localPart.length > 3 ? '*'.repeat(localPart.length - 3) : '';
    const maskedLocal = visiblePart + restLocal;

    const domainParts = domainPart.split('.');
    const extension = domainParts.pop() || '';
    const domainName = domainParts.join('.');

    const maskedDomain = '*'.repeat(domainName.length);

    return `${maskedLocal}@${maskedDomain}.${extension}`;
  }
}